/* eslint-disable */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useApiGet, useApiPost } from '../../apiCalls/useApi'
import { createAlertBreach, getBreachIdsByAlertId, getBreachList } from '../../apiCalls/breachApi'
import { DataGrid } from '@mui/x-data-grid'

interface AddToBreachDialogProps {
  open: boolean
  alertId: string
  onClose: () => void
}

export default function AddToBreachDialog({ open, onClose, alertId }: AddToBreachDialogProps) {
  const [selectedBreach, setSelectedBreach] = useState<string[]>([])
  const [breachList, setBreachList] = useState<any>({
    data: [],
    pageInfo: {},
  })
  const fetchBreachList = useApiGet(getBreachList)
  const createAlertBreachRecord = useApiPost(createAlertBreach)
  const fetchBreachIdsByAlertId = useApiGet(getBreachIdsByAlertId)

  useEffect(() => {
    if (!alertId) return
    fetchBreachIdsByAlertId({ alertId }).then((res: any) => {
      if (!res || !res.data || res.error) return
      setSelectedBreach(res.data)
    })
  }, [alertId, open])

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 0.5,
    },
    { field: 'breachName', headerName: 'Breach Name', flex: 1.5 },
    {
      field: 'reportDate',
      headerName: 'Report Date',
      flex: 1,
      valueFormatter: (params: any) => {
        return dayjs(params.value).format('YYYY-MM-DD')
      },
    },
    {
      field: 'openDate',
      headerName: 'Open Date',
      flex: 1,
      valueFormatter: (params: any) => {
        return dayjs(params.value).format('YYYY-MM-DD')
      },
    },
    { field: 'severity', headerName: 'Severity', flex: 1 },
    { field: 'status', headerName: 'Status', flex: 1 },
  ]

  useEffect(() => {
    fetchBreachList({
      startDate: dayjs('2000-01-01').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
    }).then((res) => {
      if (!res || !res.data || res.error) return
      setBreachList({
        data: res.data,
        pageInfo: {},
      })
    })
  }, [])

  const handleSubmit = () => {
    createAlertBreachRecord({
      alertId,
      breachIds: selectedBreach,
    }).then((res: any) => {
      if (res?.error) return
      onClose()
      setSelectedBreach([])
    })
  }

  const handleClose = () => {
    setSelectedBreach([])
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} sx={{ zIndex: 10000 }} fullWidth maxWidth='lg'>
      <DialogTitle>Select Breach</DialogTitle>
      <DialogContent>
        <DataGrid
          checkboxSelection
          rowSelectionModel={selectedBreach}
          onRowSelectionModelChange={(selectionModel: any) => {
            setSelectedBreach(selectionModel)
          }}
          columns={columns}
          rows={breachList?.data || []}
          sx={{
            border: 0,
            '& .MuiDataGrid-row:hover': {
              backgroundColor: 'rgba(235, 235, 235, 0.7)',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#FFFFFF',
              color: '#5B5B5B',
              fontSize: '15px',
              fontFamily: 'Segoe UI',
              borderBottom: '2px solid #BABABA',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: `1px solid #BABABA`,
              fontSize: '12px',
              cursor: 'pointer',
              fontFamily: 'Segoe UI',
              fontWeight: '600',
            },
            '& .MuiDataGrid-columnSeparator': {
              display: 'none',
            },
            '& ::-webkit-scrollbar': {
              width: '5px',
            },
            '& ::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1',
            },
            '& ::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '5px',
              '&:hover': {
                backgroundColor: '#555',
              },
            },
            '& .MuiDataGrid-toolbarContainer .MuiButtonBase-root': {
              color: '#5B5B5B',
            },
            '& .MuiDataGrid-toolbarContainer .MuiSvgIcon-root': {
              fill: '#5B5B5B',
            },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant='contained' disabled={selectedBreach.length === 0}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  )
}
